<div class="hero-dark"></div>
@if(loading_page){
<div class="backdrop-mini-loader">
  <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
</div>
}@else { @if(travel){
<div class="container">
  <h1>Gestione del <span class="green">viaggio</span></h1>
  <span>Rif #{{ travel.internal_code }}</span>

  <div class="profile-container mt-4 mb-6">
    <div class="grid">
      <div class="col-12 xl:col-4 md:pr-4">
        <div class="profile-card card-sticky">
          <div
            class="bg-travel"
            [ngStyle]="{
              'background-image':
                'url(' +
                (travel | travelImagePipe | imagePipe : 'travel' : 'lg') +
                ')'
            }"
          ></div>
          <div class="info flex flex-column justify-content-between">
            <div class="flex align-items-center gap-2">
              @if(travel.funding){
              <h2 class="badge-gmg flex align-items-center gap-2 mt-0 mb-">
                <i class="pi pi-map text-2xl"></i>
                {{ travel.name }}
              </h2>

              }@else{
              <h2 class="mt-0 mb-2">{{ travel.name }}</h2>
              }
            </div>
            @if(travel.from_date && travel.to_date){
            <span>
              {{ travel.from_date | date : "dd MMMM yyyy" }} -
              {{ travel.to_date | date : "dd MMMM yyyy" }}
            </span>
            } @if(!travel.funding){
            <div class="flex flex-column gap-2 mt-3">
              <div class="flex align-items-center gap-2">
                <i class="pi pi-users"></i>
                <small
                  >{{ travel.availability?.booked || 0 }} partecipanti su
                  {{ travel.availability?.max }}</small
                >
              </div>
              <p-progressBar [value]="progressValue"></p-progressBar>
            </div>
            } @if (loading) {
            <p-skeleton width="100%" height="4rem" class="mt-3" />
            }@else {
            <div
              [ngClass]="{
                'justify-content-between': !travel.funding,
                'justify-content-start': travel.funding
              }"
              class="flex align-items-end mt-4"
            >
              <div>
                @if(!earned && !to_earn ){
                <div class="empty-message mb-2">Nessun dato disponibile</div>

                } @else{ @if(!travel.funding){
                <small>Incassati:</small>
                @if(earned){
                <h4 class="m-0">
                  @let earned_netto = travel.customer_pays_fees ? (earned * 100
                  / 103) : earned;
                  {{
                    earned_netto
                      | currency : travel.currency : "symbol" : ".0-2"
                  }}
                </h4>
                }
                <small>Da incassare:</small>
                @if(to_earn){
                <h4 class="m-0">
                  @let to_earn_netto = travel.customer_pays_fees ? (to_earn *
                  100 / 103) : to_earn;
                  {{
                    to_earn_netto
                      | currency : travel.currency : "symbol" : ".0-2"
                  }}
                </h4>
                }}}
              </div>

              <div>
                @if(!total){
                <small></small>
                }@else{ @if(!travel.funding){
                <small>Totale:</small>
                @if(total){
                <h2 class="m-0 green">
                  @let total_netto = travel.customer_pays_fees ? (total * 100 /
                  103) : total;
                  {{
                    total_netto || 0
                      | currency : travel.currency : "symbol" : ".0-2"
                  }}
                </h2>
                }}@else {

                <div class="flex gap-5 mb-3">
                  <div>
                    <small>Totale donazioni:</small>
                    <h2 class="m-0 green">
                      {{
                        totalDonated(donations)
                          | currency : "EUR" : "symbol" : ".0-2"
                      }}
                    </h2>
                  </div>
                  <div>
                    <small>Totale adesioni:</small>
                    <h2 class="m-0 green">
                      {{ total | currency : "EUR" : "symbol" : ".0-2" }}
                    </h2>
                  </div>
                </div>
                }}
              </div>
            </div>
            }
          </div>
        </div>
      </div>

      <div class="col-12 xl:col-8">
        <div class="flex align-items-center justify-content-between gap-2 mb-3">
          <div>
            @if(!travel.funding){
            <p-button
              label="Aggiungi prenotazione"
              size="small"
              styleClass="slide-o px-4"
              (click)="goToCheckout()"
              [disabled]="
                travel.availability?.booked === travel.availability?.max
              "
            ></p-button>
            }
          </div>

          <div class="p-green">
            <p-button
              label="Report Excel"
              size="small"
              styleClass="slide-o px-4"
              (click)="downloadFinancialReport()"
            ></p-button>
          </div>
        </div>
        <div>
          <!-- FILTRI -->
          <div class="mt-4">
            <form [formGroup]="frmFilter">
              <div class="grid">
                <div class="col-4">
                  <input
                    type="text"
                    placeholder="Filtra per intestatario"
                    pInputText
                    class="w-full"
                    formControlName="created_by_account_holder"
                  />
                </div>
                <div class="col-4">
                  <input
                    type="text"
                    placeholder="Filtra per n. pratica"
                    pInputText
                    class="w-full"
                    formControlName="identifier"
                  />
                </div>
                <div class="col-4">
                  <input
                    type="text"
                    placeholder="Filtra per stato"
                    pInputText
                    class="w-full"
                    formControlName="stato"
                  />
                </div>
                <div class="col-4">
                  <input
                    type="text"
                    placeholder="Filtra per utente"
                    pInputText
                    class="w-full"
                    formControlName="created_by"
                  />
                </div>
                <div class="col-4">
                  <p-calendar
                    formControlName="range_dates"
                    dateFormat="dd/mm/yy"
                    appendTo="body"
                    panelStyleClass="custom-calendar"
                    [touchUI]="false"
                    placeholder="Filtra per date"
                    [readonlyInput]="true"
                    [showClear]="true"
                    [firstDayOfWeek]="1"
                    appendTo="body"
                    selectionMode="range"
                    styleClass="mt-0"
                  ></p-calendar>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="mt-3">
          <!-- @if (loading) {
                                    <p-skeleton width="100%" height="4rem" class="mt-3"/>
                                }@else { -->
          <!-- PROVA -->
          <div class="mt-4">
            <p-tabView
              [(activeIndex)]="activeIndex"
              [styleClass]="travel.funding === false ? 'hideNavigator' : ''"
            >
              <p-tabPanel header="Adesioni">
                @for(b of bookings;track b.id){
                <div class="shadow-xl p-3 my-4 profile-card border-round">
                  <!-- Codice in alto a sinistra -->

                  <div
                    class="mb-2 flex align-items-center justify-content-between surface-50 border-round"
                  >
                    <div class="p-2">
                      <span class="text-xs grey-text">Numero Pratica </span>
                      <b
                        class="link-o"
                        (click)="openTravelManagementModal(b.identifier)"
                        >#{{ b.identifier }}</b
                      >
                    </div>
                    <div class="p-2">
                      <span class="text-xs grey-text">Acquistata da </span>
                      @if (b.created_by_user.name) {
                      <a
                        [routerLink]="[
                          '/user/profile',
                          b.created_by_user.username
                        ]"
                        class="font-bold link-o"
                        >{{ b.created_by_user.name }}
                        {{ b.created_by_user.last_name }}</a
                      >
                      }@else {
                      <a
                        [routerLink]="[
                          '/user/profile',
                          b.created_by_user.username
                        ]"
                        class="font-bold link-o"
                        >{{ b.created_by_user.username }}</a
                      >
                      }
                    </div>
                    <div class="p-2">
                      <span class="text-xs grey-text block"> In data </span>

                      <span class="font-bold">{{
                        b.created_on | date : "dd/MM/yyyy"
                      }}</span>
                    </div>
                    <div class="p-2">
                      <span class="text-xs grey-text block">
                        Intestatario pratica
                      </span>
                      <span class="font-bold"
                        >{{ b.accountholder_name }}
                        {{ b.accountholder_last_name }}</span
                      >
                    </div>
                  </div>

                  <!-- Contenuto della card -->

                  <div class="grid">
                    <div class="col-4 flex-column">
                      <!-- totale metodo pag -->
                      <div class="pt-3">
                        <span class="block mb-2">Totale</span>
                        @if(!travel.funding){
                        <span style="color: #4abcc4">
                          {{
                            b.amount
                              | currency : travel.currency : "symbol" : ".0-2"
                          }}</span
                        >} @else {
                        <span style="color: #4abcc4">
                          {{
                            sumPayments(b.payments)
                              | currency : travel.currency : "symbol" : ".0-2"
                          }}</span
                        >}
                        <br />
                        @if(travel.customer_pays_fees){
                        <span class="text-xs grey-text">Costi esclusi</span>}
                      </div>
                    </div>
                    <!-- Viaggio GMG -->
                    @if(!travel.funding) {
                    <!-- Viaggio std -->
                    @let acconto = b | bookingPaymentByType:'advance'; @let
                    saldo = b | bookingPaymentByType:'payoff'; @if(acconto){
                    <div class="col">
                      <!-- TABELLA ACCONTO -->
                      <div class="pt-3">
                        <div class="flex items-center">
                          <span class="block mr-2 mb-2">Acconto</span>
                          @if(acconto?.status?.id === enumPaymentStatus.PAYED){
                          <div class="flex items-center mt-0">
                            <span
                              [innerHTML]="acconto.type | paymentMethod"
                            ></span>
                          </div>
                          }
                        </div>

                        {{
                          acconto
                            | paymentAmount : travel.customer_pays_fees
                            | currency : travel.currency : "symbol" : ".0-2"
                        }}
                        <br />
                        @if (travel.customer_pays_fees) {
                        <span class="text-xs grey-text"
                          >Costi
                          {{
                            ((acconto.amount * 100) / 103) * 0.03
                              | currency : travel.currency : "symbol" : ".0-2"
                          }}</span
                        >
                        }
                        <div
                          class="text-sm"
                          [innerHTML]="acconto.status.id | paymentStatus"
                        ></div>
                      </div>

                      <!-- <table class="p-3 w-full surface-500 border-round mt-3">
                  <tbody>
                    <tr>
                      <td class="text-sm font-semibold text-900">Acconto</td>
                      <td class="text-right text-base font-bold text-700">
                        {{
                          acconto
                            | paymentAmount : travel.customer_pays_fees
                            | currency : travel.currency : "symbol" : ".0-2"
                        }}
                      </td>
                    </tr>

                    @if (travel.customer_pays_fees) {
                    <tr>
                      <td class="text-sm font-semibold text-900">Costi</td>
                      <td class="text-right text-base font-medium text-700">
                        {{
                          ((acconto.amount * 100) / 103) * 0.03
                            | currency : travel.currency : "symbol" : ".0-2"
                        }}
                      </td>
                    </tr>
                    }

                    <tr>
                      <td class="text-sm font-semibold text-900">Stato</td>
                      <td class="text-right">
                        @if (enumPaymentStatus.PAYED) {
                        <span class="text-xs text-600 mr-2">
                          {{ acconto.payed_on | date }}
                        </span>
                        }
                        <span
                          class="text-sm"
                          [innerHTML]="acconto.status.id | paymentStatus"
                        ></span>
                      </td>
                    </tr>
                  </tbody>
                </table> -->
                    </div>
                    } @if(saldo){
                    <div class="col">
                      <!-- TABELLA SALDO -->
                      <!-- <table class="p-3 w-full surface-50 border-round mt-3">
                  <tbody>
                    <tr>
                      <td class="text-sm font-semibold text-900">Saldo</td>
                      <td class="text-right text-base font-bold text-700">
                        {{
                          saldo
                            | paymentAmount : travel.customer_pays_fees
                            | currency : travel.currency : "symbol" : ".0-2"
                        }}
                      </td>
                    </tr>

                    @if (travel.customer_pays_fees) {
                    <tr>
                      <td class="text-sm font-semibold text-900">Costi</td>
                      <td class="text-right text-base font-medium text-700">
                        {{
                          ((saldo.amount * 100) / 103) * 0.03
                            | currency : travel.currency : "symbol" : ".0-2"
                        }}
                      </td>
                    </tr>
                    }

                    <tr>
                      <td class="text-sm font-semibold text-900">Stato</td>
                      <td class="text-right">
                        <span
                          class="text-sm"
                          [innerHTML]="saldo.status.id | paymentStatus"
                        ></span>
                        @if (enumPaymentStatus.PAYED) {
                        <span class="text-xs text-600 ml-1">
                          {{ saldo.payed_on | date }}
                        </span>
                        }
                      </td>
                    </tr>
                  </tbody>
                </table> -->
                      <div class="pt-3">
                        <div class="flex items-center">
                          <span class="block mr-2 mb-2">Saldo</span>
                          @if(saldo?.status?.id === enumPaymentStatus.PAYED){
                          <div class="flex items-center mt-2">
                            <span
                              [innerHTML]="saldo.type | paymentMethod"
                            ></span>
                          </div>
                          }
                        </div>

                        {{
                          saldo
                            | paymentAmount : travel.customer_pays_fees
                            | currency : travel.currency : "symbol" : ".0-2"
                        }}
                        <br />
                        @if (travel.customer_pays_fees) {
                        <span class="text-xs grey-text"
                          >Costi
                          {{
                            ((saldo.amount * 100) / 103) * 0.03
                              | currency : travel.currency : "symbol" : ".0-2"
                          }}</span
                        >
                        }
                        <div
                          class="text-sm"
                          [innerHTML]="saldo.status.id | paymentStatus"
                        ></div>
                      </div>
                    </div>

                    } }
                  </div>
                </div>

                }@empty {
                <div class="empty-message mt-10 mb-2">
                  Nessun dato disponibile
                </div>
                }
                <p-paginator
                  (onPageChange)="getAllBookings($event)"
                  [first]="first"
                  [rows]="rows"
                  [totalRecords]="totalRecords"
                  [showCurrentPageReport]="true"
                  [showPageLinks]="true"
                  currentPageReportTemplate="Risultati {first} - {last} di {totalRecords}"
                />
              </p-tabPanel>

              <p-tabPanel header="Donazioni">
                @for(d of donations;track d.identifier){
                <div class="shadow-xl p-3 my-4 profile-card border-round">
                  <!-- Codice in alto a sinistra -->

                  <div
                    class="mb-2 flex align-items-center justify-content-between surface-50 border-round"
                  >
                    <div class="p-2">
                      <span class="text-xs grey-text">N.Riferimento </span>
                      <b class="link-o">#{{ d.identifier }}</b>
                    </div>
                    <div class="p-2">
                      <span class="text-xs grey-text block">Donato da </span>
                      @if (d.anonymous===false) {
                      <span class="font-bold"
                        >{{ d.accountholder_name }}
                        {{ d.accountholder_last_name }}</span
                      >
                      }@else {
                      <span class="font-bold">Anonimo</span>
                      }
                    </div>
                    <div class="p-2">
                      <span class="text-xs grey-text block"> In data </span>

                      <span class="font-bold">{{
                        d.created_on | date : "dd/MM/yyyy"
                      }}</span>
                    </div>
                    <div class="p-2">
                      <span class="text-xs grey-text block">
                        Intestatario pratica
                      </span>
                      <span class="font-bold"
                        >{{ d.accountholder_name }}
                        {{ d.accountholder_last_name }}</span
                      >
                    </div>
                  </div>

                  <!-- Contenuto della card -->

                  <div class="grid">
                    <div class="col-4 flex-column">
                      <!-- totale metodo pag -->
                      <div class="pt-3">
                        <span class="block mb-2">Totale</span>

                        <span style="color: #4abcc4">
                          {{
                            d.payment.amount
                              | currency : travel.currency : "symbol" : ".0-2"
                          }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>

                }@empty {
                <div class="empty-message mt-10 mb-2">
                  Nessun dato disponibile
                </div>
                }
              </p-tabPanel>
              <!-- PROVA -->
              <!-- } -->
            </p-tabView>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
} }
